import { render, staticRenderFns } from "./DSubTitlePreview.vue?vue&type=template&id=6098e824&"
import script from "./DSubTitlePreview.vue?vue&type=script&lang=js&"
export * from "./DSubTitlePreview.vue?vue&type=script&lang=js&"
import style0 from "./DSubTitlePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports